import React, { useEffect } from 'react';
import { Icon, Card } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './unverifiedBlocker.css';

interface UnverifiedBlockerProps {
  onLogout: () => void;
  timeout: number;
}

export const UnverifiedBlocker = ({
  onLogout,
  timeout,
}: UnverifiedBlockerProps) => {
  useEffect(() => {
    const instance = setTimeout(onLogout, timeout);
    return () => clearTimeout(instance);
  }, [onLogout, timeout]);

  return (
    <div data-test-id='unverified-blocker-container' className={styles.unverifiedBlocker}>
      <Card className={styles.card}>
        <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
        <h3 data-test-id='unverified-blocker-title' className={styles.title}>{getMessage('pluginLoad.error')}</h3>
        <p className={styles.body} data-test-id="unverified-message">
          {getMessage('general.unverifiedAccountError')}
        </p>
      </Card>
    </div>
  );
};
